var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5414 17.1875C9.4139 17.1875 9.2864 17.1875 9.1589 17.18C4.9589 16.9925 1.4489 13.61 1.1564 9.48499C0.901403 5.94499 2.9489 2.63749 6.2489 1.24999C7.1864 0.859994 7.6814 1.15999 7.8914 1.37749C8.1014 1.58749 8.3939 2.07499 8.0039 2.96749C7.6589 3.76249 7.4864 4.60999 7.4939 5.47999C7.5089 8.80249 10.2689 11.6225 13.6364 11.7575C14.1239 11.78 14.6039 11.7425 15.0689 11.66C16.0589 11.48 16.4714 11.8775 16.6289 12.1325C16.7864 12.3875 16.9664 12.935 16.3664 13.745C14.7764 15.92 12.2489 17.1875 9.5414 17.1875ZM2.2739 9.40249C2.5289 12.9725 5.5739 15.8975 9.2039 16.055C11.6714 16.175 14.0114 15.05 15.4514 13.085C15.5639 12.9275 15.6164 12.815 15.6389 12.755C15.5714 12.7475 15.4514 12.74 15.2639 12.7775C14.7164 12.875 14.1464 12.9125 13.5839 12.89C9.6239 12.7325 6.3839 9.40999 6.3614 5.49499C6.3614 4.45999 6.5639 3.46249 6.9764 2.52499C7.0514 2.35999 7.0664 2.24749 7.0739 2.18749C7.0064 2.18749 6.8864 2.20249 6.6914 2.28499C3.8339 3.48499 2.0639 6.34999 2.2739 9.40249Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon-icon.1ef9d3a2b7a3dd768947f54d9b3c6aab.svg";
export { ForwardRef as ReactComponent };